import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import ActionsDesktop from '@components/order/actions-desktop';
import DetailsDesktop from '@components/order/details-desktop';
import { Box, useMediaQuery } from '@mui/material';
import { StyledIcon } from '@elements/icon/icon.styles';
import EmptyTicket from '@images/empty-ticket.svg';
import { useDeviceSize } from '@hooks/useDeviceSize';
import renderTickets from '@components/ticket/render-tickets';
import DetailsMobile from './details-mobile';
import ActionsMobile from './actions-mobile';
import { Typography } from '@elements';
import ChevronDownIcon from '@images/chevron-down.svg';
import ChevronUpIcon from '@images/chevron-up.svg';
import AsideButton from './aside-button';
import BuyMoreAsideLink from './buy-more-aside-link';
import { Link } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var getFirstTickets = function getFirstTickets(eventSessions) {
  var ticketsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var orderUuid = arguments.length > 2 ? arguments[2] : undefined;
  var tickets = [];
  for (var i = 0; i < eventSessions.length; i++) {
    var _eventSessions$i$seat;
    var seats = (_eventSessions$i$seat = eventSessions[i].seats) !== null && _eventSessions$i$seat !== void 0 ? _eventSessions$i$seat : [];
    for (var j = 0; j < seats.length; j++) {
      tickets.push(_objectSpread(_objectSpread({}, eventSessions[i]), {}, {
        seats: [seats[j]],
        _uniqueKey: "".concat(orderUuid, "-").concat(eventSessions[i].id, "-").concat(j)
      }));
      if (tickets.length === ticketsCount) {
        return tickets;
      }
    }
  }
  return tickets;
};
var Order = function Order(_ref) {
  var order = _ref.order;
  var _useDeviceSize = useDeviceSize(),
    mobile = _useDeviceSize.mobile;
  var _order$eventSessions$ = order.eventSessions.reduce(function (acc, eventSession) {
      var _eventSession$seats;
      var seats = (_eventSession$seats = eventSession.seats) !== null && _eventSession$seats !== void 0 ? _eventSession$seats : [];
      var sessionCount = seats.length;
      var _seats$reduce = seats.reduce(function (seatAcc, ticket) {
          seatAcc.sessionPrice += ticket.price;
          seatAcc.sessionPaidAmount += ticket.paidAmount;
          seatAcc.sessionDiscountAmount += ticket.discountAmount;
          return seatAcc;
        }, {
          sessionPrice: 0,
          sessionPaidAmount: 0,
          sessionDiscountAmount: 0
        }),
        sessionPrice = _seats$reduce.sessionPrice,
        sessionPaidAmount = _seats$reduce.sessionPaidAmount,
        sessionDiscountAmount = _seats$reduce.sessionDiscountAmount;
      acc.count += sessionCount;
      acc.price += sessionPrice;
      acc.paidAmount += sessionPaidAmount;
      acc.discountAmount += sessionDiscountAmount;
      return acc;
    }, {
      count: 0,
      price: 0,
      paidAmount: 0,
      discountAmount: 0
    }),
    count = _order$eventSessions$.count,
    price = _order$eventSessions$.price,
    paidAmount = _order$eventSessions$.paidAmount,
    discountAmount = _order$eventSessions$.discountAmount;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ticketsShown = _React$useState2[0],
    setTicketsShown = _React$useState2[1];
  var desktopMiddleWidth = useMediaQuery(function (theme) {
    return theme.breakpoints.between('md', 'lg');
  });
  var desktopLargeWidth = useMediaQuery(function (theme) {
    return theme.breakpoints.between('lg', 'xl');
  });
  var desktopExtraLargeWidth = useMediaQuery(function (theme) {
    return theme.breakpoints.between('xl', 'xxl');
  });
  var desktopMaxWidth = useMediaQuery(function (theme) {
    return theme.breakpoints.up('xxl');
  });
  var ticketsCountInOrder = order.eventSessions.reduce(function (acc, eventSession) {
    var _eventSession$seats2;
    return acc + ((_eventSession$seats2 = eventSession.seats) !== null && _eventSession$seats2 !== void 0 ? _eventSession$seats2 : []).length;
  }, 0);
  var ticketUuids = order.eventSessions.flatMap(function (es) {
    var _es$seats;
    return ((_es$seats = es.seats) !== null && _es$seats !== void 0 ? _es$seats : []).map(function (s) {
      return s.ticketUuid;
    }).filter(function (u) {
      return !!u;
    });
  });
  if (mobile) {
    return /*#__PURE__*/_jsxs(Box, {
      sx: {
        background: '#F9F9F9',
        borderRadius: '12px',
        mb: '24px'
      },
      children: [/*#__PURE__*/_jsx(DetailsMobile, {
        status: order.payStatus.toLowerCase(),
        orderNumber: order.regNum,
        orderDate: order.datetime,
        count: count,
        price: price,
        paidAmount: paidAmount,
        discountAmount: discountAmount,
        orderUuid: order.uuid
      }), /*#__PURE__*/_jsx(ActionsMobile, {
        orderUuid: order.uuid,
        ticketUuids: ticketUuids
      }), ticketsShown && /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          columnGap: '12px',
          rowGap: '32px',
          flexWrap: 'wrap',
          background: '#E7E7E7',
          justifyContent: 'center',
          py: '18px'
        },
        children: [order.eventSessions.map(function (eventSession, index) {
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: renderTickets(eventSession, order.uuid)
          }, "".concat(order.uuid, "-").concat(eventSession.id, "-").concat(index));
        }), /*#__PURE__*/_jsx(Link, {
          to: "".concat(process.env.ticketsUrl, "/events"),
          target: "_blank",
          style: {
            textDecoration: 'none'
          },
          children: /*#__PURE__*/_jsx(StyledIcon, {
            src: EmptyTicket,
            width: 288,
            height: 352
          })
        })]
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'center'
        },
        onClick: function onClick() {
          return setTicketsShown(!ticketsShown);
        },
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          },
          children: ticketsShown ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              src: ChevronDownIcon,
              width: 18,
              height: 18,
              sx: {
                transform: 'rotate(180deg)'
              }
            }), /*#__PURE__*/_jsx(Typography, {
              color: "blackSecondary",
              children: "\u0421\u043A\u0440\u044B\u0442\u044C \u0431\u0438\u043B\u0435\u0442\u044B"
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Typography, {
              color: "blackSecondary",
              children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u0438\u043B\u0435\u0442\u044B"
            }), /*#__PURE__*/_jsx(StyledIcon, {
              src: ChevronDownIcon,
              width: 18,
              height: 18
            })]
          })
        })
      })]
    });
  }
  var renderTicketsPreview = function renderTicketsPreview() {
    if (desktopMiddleWidth) {
      if (ticketsCountInOrder === 1) {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: [order.eventSessions.map(function (eventSession) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession.id);
            }), ticketsCountInOrder <= 1 && /*#__PURE__*/_jsx(BuyMoreAsideLink, {})]
          })
        });
      }
      if (ticketsCountInOrder > 1) {
        return /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: getFirstTickets(order.eventSessions, 1, order.uuid).map(function (eventSession, index) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession._uniqueKey || "".concat(order.uuid, "-").concat(eventSession.id, "-").concat(index));
            })
          }), /*#__PURE__*/_jsx(AsideButton, {
            onClick: function onClick() {
              return setTicketsShown(true);
            },
            children: /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column'
              },
              children: [/*#__PURE__*/_jsx(Typography, {
                sx: {
                  writingMode: 'tb-rl',
                  transform: 'rotate(-180deg)',
                  color: '#9E9E9E'
                },
                fontWeight: 400,
                fontSize: 16,
                children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435"
              }), /*#__PURE__*/_jsx(StyledIcon, {
                src: ChevronDownIcon,
                width: 18,
                height: 18
              })]
            })
          })]
        });
      }
    } else if (desktopLargeWidth) {
      if (ticketsCountInOrder === 1) {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: [order.eventSessions.map(function (eventSession) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession.id);
            }), /*#__PURE__*/_jsx(Link, {
              to: "".concat(process.env.ticketsUrl, "/events"),
              target: "_blank",
              style: {
                textDecoration: 'none'
              },
              children: /*#__PURE__*/_jsx(StyledIcon, {
                src: EmptyTicket,
                width: 288,
                height: 352
              })
            })]
          })
        });
      }
      if (ticketsCountInOrder === 2) {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: [order.eventSessions.map(function (eventSession) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession.id);
            }), ticketsCountInOrder <= 2 && /*#__PURE__*/_jsx(BuyMoreAsideLink, {})]
          })
        });
      }
      if (ticketsCountInOrder > 2) {
        return /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: getFirstTickets(order.eventSessions, 2, order.uuid).map(function (eventSession, index) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession._uniqueKey || "".concat(order.uuid, "-").concat(eventSession.id, "-").concat(index));
            })
          }), /*#__PURE__*/_jsx(AsideButton, {
            onClick: function onClick() {
              return setTicketsShown(true);
            },
            children: /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column'
              },
              children: [/*#__PURE__*/_jsx(Typography, {
                sx: {
                  writingMode: 'tb-rl',
                  transform: 'rotate(-180deg)',
                  color: '#9E9E9E'
                },
                fontWeight: 400,
                fontSize: 16,
                children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435"
              }), /*#__PURE__*/_jsx(StyledIcon, {
                src: ChevronDownIcon,
                width: 18,
                height: 18
              })]
            })
          })]
        });
      }
    } else if (desktopExtraLargeWidth) {
      if (ticketsCountInOrder <= 2) {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: [order.eventSessions.map(function (eventSession) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession.id);
            }), /*#__PURE__*/_jsx(Link, {
              to: "".concat(process.env.ticketsUrl, "/events"),
              target: "_blank",
              style: {
                textDecoration: 'none'
              },
              children: /*#__PURE__*/_jsx(StyledIcon, {
                src: EmptyTicket,
                width: 288,
                height: 352
              })
            })]
          })
        });
      }
      return /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          mt: '18px'
        },
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            columnGap: '12px',
            rowGap: '32px',
            flexWrap: 'wrap'
          },
          children: [getFirstTickets(order.eventSessions, 3, order.uuid).map(function (eventSession, index) {
            return /*#__PURE__*/_jsx(React.Fragment, {
              children: renderTickets(eventSession, order.uuid)
            }, eventSession._uniqueKey || "".concat(order.uuid, "-").concat(eventSession.id, "-").concat(index));
          }), ticketsCountInOrder <= 3 && /*#__PURE__*/_jsx(BuyMoreAsideLink, {})]
        }), ticketsCountInOrder > 3 && /*#__PURE__*/_jsx(AsideButton, {
          onClick: function onClick() {
            return setTicketsShown(true);
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column'
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              sx: {
                writingMode: 'tb-rl',
                transform: 'rotate(-180deg)',
                color: '#9E9E9E'
              },
              fontWeight: 400,
              fontSize: 16,
              children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435"
            }), /*#__PURE__*/_jsx(StyledIcon, {
              src: ChevronDownIcon,
              width: 18,
              height: 18
            })]
          })
        })]
      });
    } else if (desktopMaxWidth) {
      if (ticketsCountInOrder <= 4) {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            mt: '18px'
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              columnGap: '12px',
              rowGap: '32px',
              flexWrap: 'wrap'
            },
            children: [order.eventSessions.map(function (eventSession) {
              return /*#__PURE__*/_jsx(React.Fragment, {
                children: renderTickets(eventSession, order.uuid)
              }, eventSession.id);
            }), /*#__PURE__*/_jsx(Link, {
              to: "".concat(process.env.ticketsUrl, "/events"),
              target: "_blank",
              style: {
                textDecoration: 'none'
              },
              children: /*#__PURE__*/_jsx(StyledIcon, {
                src: EmptyTicket,
                width: 288,
                height: 352
              })
            })]
          })
        });
      }
      return /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          mt: '18px'
        },
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            columnGap: '12px',
            rowGap: '32px',
            flexWrap: 'wrap'
          },
          children: [getFirstTickets(order.eventSessions, 5, order.uuid).map(function (eventSession, index) {
            return /*#__PURE__*/_jsx(React.Fragment, {
              children: renderTickets(eventSession, order.uuid)
            }, eventSession._uniqueKey || "".concat(order.uuid, "-").concat(eventSession.id, "-").concat(index));
          }), ticketsCountInOrder <= 4 && /*#__PURE__*/_jsx(BuyMoreAsideLink, {})]
        }), ticketsCountInOrder > 4 && /*#__PURE__*/_jsx(AsideButton, {
          onClick: function onClick() {
            return setTicketsShown(true);
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column'
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              sx: {
                writingMode: 'tb-rl',
                transform: 'rotate(-180deg)',
                color: '#9E9E9E'
              },
              fontWeight: 400,
              fontSize: 16,
              children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435"
            }), /*#__PURE__*/_jsx(StyledIcon, {
              src: ChevronDownIcon,
              width: 18,
              height: 18
            })]
          })
        })]
      });
    }
  };
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      mb: '40px'
    },
    children: [/*#__PURE__*/_jsx(DetailsDesktop, {
      status: order.payStatus.toLowerCase(),
      orderNumber: order.regNum,
      orderDate: order.datetime,
      count: count,
      price: price,
      paidAmount: paidAmount,
      discountAmount: discountAmount,
      orderUuid: order.uuid
    }), /*#__PURE__*/_jsx(ActionsDesktop, {
      orderUuid: order.uuid,
      ticketUuids: ticketUuids
    }), !ticketsShown && renderTicketsPreview(), ticketsShown && /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        mt: '18px'
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          columnGap: '12px',
          rowGap: '32px',
          flexWrap: 'wrap'
        },
        children: [order.eventSessions.map(function (eventSession, index) {
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: renderTickets(eventSession, order.uuid)
          }, "".concat(order.uuid, "-").concat(eventSession.id, "-").concat(index));
        }), /*#__PURE__*/_jsx(Link, {
          to: "".concat(process.env.ticketsUrl, "/events"),
          target: "_blank",
          style: {
            textDecoration: 'none'
          },
          children: /*#__PURE__*/_jsx(StyledIcon, {
            src: EmptyTicket,
            width: 288,
            height: 352
          })
        })]
      }), /*#__PURE__*/_jsx(AsideButton, {
        onClick: function onClick() {
          return setTicketsShown(false);
        },
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
          },
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            src: ChevronUpIcon,
            width: 18,
            height: 18
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              writingMode: 'tb-rl',
              transform: 'rotate(-180deg)',
              color: '#9E9E9E'
            },
            fontWeight: 400,
            fontSize: 16,
            children: "\u0421\u043A\u0440\u044B\u0442\u044C"
          })]
        })
      })]
    })]
  });
};
export default Order;